<template>
    <component v-if="ready" :is="SkinComponent" v-bind="$attrs" :notices="notices" :summary="summary" :boards="boards" :filter="filter" :page="page" :limit="limit" @click="click" @search="search" :hideWriteButton="hideWriteButton">
        <template #write-button>
            <v-btn v-if="scope.find(scope => writeScope.includes(scope))" x-large color="primary" @click="write">글쓰기</v-btn>
        </template>
        <template #pagination>
            <pagination-component :value="page" :count="Math.ceil(summary.totalCount / limit)" @input="value => onPage(value)"></pagination-component>
        </template>
    </component>
</template>

<script>
import api from "@/api";

import PaginationComponent from "@/components/client/control/pagination-component.vue";

export default {
    components: {
        PaginationComponent
    },
    props: {
        skin: { type: String, default: null },
        code: { type: String, default: null },
        category: {}, 

        writeScope: { type: Array, default(){ return [] } },
        hideWriteButton: { type: Boolean, default: false },

        to: String,
    },
    data() {
        return {
            ready: false,

            filter: {
                code: this.$props.code,
                category: this.$props.category,
                searchKey: "",
                searchValue: "",
                status: "closeAndOpen"
            },

            page: +this.$route.query.page || +this.$attrs.page || 1,
            skip: this.$attrs.skip || ((this.$route.query.page || this.$attrs.page || 1) - 1) * this.$attrs.limit,
            limit: +this.$attrs.limit || 10,

            summary: { totalCount: 0 },
            boards: [],
            notices: [],
            categories: [
                { code: "guide", name: "코인거래소 가입", value: "코인거래소 가입" },
                { code: "guide", name: "이더리움 구매", value: "이더리움 구매" },
                { code: "guide", name: "메타마스크 가입", value: "메타마스크 가입" },
                { code: "guide", name: "오픈씨 계정 가입", value: "오픈씨 계정 가입" },
                { code: "guide", name: "작품구입 및 판매활동", value: "작품구입 및 판매활동" },
            ]
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            await this.getNotices();
            await this.search(false);
            this.ready = true;
        },

        async getNotices() {
            try {
                var { boards: notices } = await api.v1.boards.gets({
                    params: { ...this.filter, isNotice: true },
                    headers: {
                        code: this.code
                    }
                });

                this.notices = notices;
            } catch (error) {
                this.handleError(error);
            }
        },

        async search(routable = true, loadmore = false) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, { page: this.headers.page }),
                    });
                }
                var { summary, boards } = await api.v1.boards.gets({
                    headers: {
                        code: this.code,
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit
                    },
                    params: this.filter,
                });

                this.summary = summary;
                
                //종료된 이벤트 검색 시,
                if(this.code === "event" && this.filter.status == "closeAndOpen") {
                    boards = this.filterClosedEvents(boards);
                }

                this.boards = loadmore ? [...this.boards, ...boards] : boards;
            } catch (error) {
                this.handleError(error);
            }
        },

        write(){
            this.$router.push(`${this.to || this.$route.path}/create`);
        },

        click(board){
            this.$router.push(`${this.to || this.$route.path}/${board._id}`);
        },

        onLoadmore() {
            this.headers.skip = this.boards.length;
            this.search(true, true);
        },

        onPage(page, routable = true) {
            this.headers.page = page;
            this.headers.skip = (page - 1) * this.limit;
            this.search(routable);
        },

        filterClosedEvents(boards) {
            const today = this.$dayjs();
            return boards.filter((item) => {
                let { display: { endDate = null }, status } = item;
                const formatEndDate = this.$dayjs(endDate).endOf('day');

                // 진행완료 이거나 기간이 지났을 경우
                return status === "close" || today.isAfter(formatEndDate);
            });
        },

        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    computed: {
        scope(){
            return this.$store.state.payload?.scope || [];
        },
        SkinComponent() {
            return () => import(`./skin/${this.$props.skin}/list.vue`);
        },
    },
    watch: {
        "$route.query.page"() {
            this.onPage(+this.$route.query.page || 1, false);
        },
    },
};
</script>
